// Brand colors
export const COLORS = {
    black: '#0B0D10',
    blackSecondary: '#111318',
    blackBorder: '#1F232B',
    accent: '#20C5F5',
    accentHover: '#4DD3F8',
    // Darker cyan for text/links on light backgrounds (bright cyan fails contrast on white)
    accentOnLight: '#0784AD',
    muted: '#6B7280',
    mutedOnDark: '#A1A7B3',
    light: '#F5F7F9',
    white: '#FFFFFF',
    border: '#E3E7EC',
}

export const SITE = {
    name: 'Thomas Viles',
    domain: 'tviles.com',
    url: 'https://tviles.com',
    email: 'tcv720@gmail.com', // TODO(Thomas): switch to a business address (e.g. hello@tviles.com) if you set one up
    location: 'Indianapolis, Indiana',
    tagline: 'Automation • Consulting • Mentoring',
    manualTagline: 'Still doing that manually?',
    manualPunchline: 'I can automate it.',
    resumePdf: 'https://drive.google.com/file/d/1ktopzMZJGPbk__ZifSyG3mM1GZP39jux/view?usp=drive_link',
    linkedin: 'https://www.linkedin.com/in/thomasvilesjr/',
    linkedinRecommendations: 'https://www.linkedin.com/in/thomasvilesjr/details/recommendations/',
    github: 'https://github.com/Tcviles',
}

export const MAX_WIDTH = 1180
